import { gql } from '../__generated__';

export const GET_USER = gql(`
  query GetUser($id: Int!) {
    user: getUser(id: $id) {
      ...UserItem
    }
  }
`);

export const GET_USERS = gql(`
  query GetUsers(
    $page: Int!
    $pageSize: Int!
    $onlyActive: Boolean!
    $activeSingleDocument: Boolean!
    $nonActiveSingleDocument: Boolean!
    $nonActiveForNumberYears: Int!
    $filter: String!
  ) {
    users: getUsers(
      page: $page
      pageSize: $pageSize
      onlyActive: $onlyActive
      activeSingleDocument: $activeSingleDocument
      nonActiveSingleDocument: $nonActiveSingleDocument
      nonActiveForNumberYears: $nonActiveForNumberYears
      filter: $filter
    ) {
      users {
        id
        displayName
        loginId
        email
        lastLoggedIn
        isActive
        isAdminuserOnActiveLicense
      }
      count
    }
  }
`);

export const GET_USERS_FROM_LICENSE = gql(`
  query GetUsersFromLicense($licenseId: String!) {
    users: getUsersFromLicense(licenseId: $licenseId) {
      id
      name
      numberOfUsers
      users {
        id
        userSubscriptionId
        firstName
        lastName
        email
        lastLoggedIn
        displayName
      }
    }
  }
`);

export const GET_USE_LOG = gql(`
  query GetUseLog($userId: String!, $fromDate: DateTimeOffset!, $toDate: DateTimeOffset) {
    logs: getUseLog(userId: $userId, fromDate: $fromDate, toDate: $toDate) {
      docId
      docName
      docNumber
      title
      publishedYear
      price
      visitCount
      medium
    }
  }
`);

export const UPDATE_NAME = gql(`
  mutation UpdateName($input: UserUpdateNameInput!) {
    userUpdateName(input: $input) {
      id
      firstName
      lastName
      displayName
    }
  }
`);

export const UPDATE_LOGIN = gql(`
  mutation UpdateLogin($input: UserUpdateLoginIdInput!) {
    userUpdateLoginId(input: $input) {
      id
      loginId
    }
  }
`);

export const UPDATE_EMAIL = gql(`
  mutation UpdateEmail($input: UserUpdateEmailInput!) {
    userUpdateEmail(input: $input) {
      id
      email
    }
  }
`);

export const UPDATE_PHONE = gql(`
  mutation UpdatePhone($input: UserUpdatePhoneInput!) {
    userUpdatePhone(input: $input) {
      id
      phone
    }
  }
`);

export const UPDATE_ADDRESS = gql(`
  mutation UpdateAddress($input: UserUpdateAddressInput!) {
    userUpdateAddress(input: $input) {
      id
      address {
        id
        address1
        address2
        postalCode
        city
        country
      }
    }
  }
`);

export const DELETE_CUSTOMER = gql(`
  mutation DeleteCustomer($input: UserDeleteInput!) {
    userDelete(input: $input) {
      id
      error
    }
  }
`);

export const GET_ACCESSES = gql(`
  query GetUserAccesses($id: Int!) {
    userAccess: getUserAccess(userId: $id) {
      id
      isDeleted
      license {
        id
        companyName
      }
      subscription {
        id
        name
      }
      createdAt
    }
  }
`);

export const GET_LAST_RESET_PASSWORD_URL = gql(`
  query GetLastResetPasswordUrl($id: Int!) {
    url: getLastResetPasswordUrl(userId: $id)
  }
`);

export const GET_BOUNCED = gql(`
  query GetBounced($id: Int!) {
    bounced: getUserBounced(id: $id) {
      id
      isBounced
      reason
    }
  }
`);

export const REMOVE_BOUNCE = gql(`
  mutation RemoveBounce($input: UserRemoveBounceInput!) {
    userRemoveBounce(input: $input) {
      id
      isBounced
      reason
    }
  }
`);

export const GET_LICENSES_WHERE_IS_ADMIN = gql(`
  query GetLicensesWhereIsAdmin($id: Int!) {
    licenses: getLicensesForAdministrator(userId: $id) {
      id
      companyName
    }
  }
`);

export const GET_USER_ACCESS_HISTORY = gql(`
  query GetUserAccessHistory($id: Int!) {
    accesses: getUserAccessHistory(userId: $id) {
      subscriptionId
      subscriptionName
      licenseId
      licenseName
      from
      to
    }
  }
`);
